import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeComponentLinkSkeleton } from './TypeComponentLink'

export interface TypeResourceImageFields {
  internalName?: EntryFieldTypes.Symbol
  image: EntryFieldTypes.AssetLink
  imageDarkMode?: EntryFieldTypes.AssetLink
  link?: EntryFieldTypes.EntryLink<TypeComponentLinkSkeleton>
  showCaption?: EntryFieldTypes.Boolean
  caption?: EntryFieldTypes.Symbol
  captionSize?: EntryFieldTypes.Symbol<'Large' | 'Small'>
  zoomable?: EntryFieldTypes.Boolean
  hideInPrintView?: EntryFieldTypes.Boolean
  noOptimization?: EntryFieldTypes.Boolean
  imageShadow?: EntryFieldTypes.Boolean
  roundedCorners?: EntryFieldTypes.Boolean
}

export type TypeResourceImageSkeleton = EntrySkeletonType<TypeResourceImageFields, 'resourceImage'>
export type TypeResourceImage<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeResourceImageSkeleton,
  Modifiers,
  Locales
>

export function isTypeResourceImage<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeResourceImage<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'resourceImage'
}
